module.exports = __webpack_public_path__ + "static/media/write.f221546e.png";